import type { File } from '@/modules/files/components/file-picker/FileMenuItem';
import { FilePicker } from '@/modules/files/components/file-picker';

export interface RootOwner {
  _id: string;
  type: 'Group' | 'Service';
  machineName: string;
}

interface Props {
  rootOwner: RootOwner;
  open: boolean;
  parentId: string | null | undefined;
  onClose: () => void;
  onSelect: (
    fileId: string | null | undefined,
    ownerId: string,
    file: File | null | undefined,
  ) => void;
  setParentId: (parentId: string | undefined | null) => void;
}

export const FileSelectorDialog = ({
  rootOwner,
  open,
  parentId,
  onClose,
  onSelect,
  setParentId,
}: Props) => {
  return (
    <FilePicker
      selectionMode="both"
      preventRootSelection
      rootOwner={rootOwner}
      parentId={parentId}
      title="Select a file"
      open={open}
      onClose={onClose}
      fileActionName="Select"
      parentActionName="Select this"
      onChangeParent={setParentId}
      onSelect={onSelect}
    />
  );
};
